import React from "react";
import { bool, node } from "prop-types";
import cx from "classnames";
import Loading from "../Loading/Loading.jsx";

const propTypes = {
  children: node.isRequired,
  isLoading: bool,
  header: node,
  pagination: node,
};

const Results = props => {
  const { children, header, isLoading, pagination } = props;

  return (
    <div
      className={cx("results", {
        "results--loading": isLoading,
      })}
    >
      <Loading isLoading={isLoading} />
      <div className="container container--100">
        {header}
        <div className="results__grid">{children}</div>
        {pagination && <div className="results__pagination">{pagination}</div>}
      </div>
    </div>
  );
};

Results.propTypes = propTypes;
export default Results;
